<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    append-to-body
    :show-close="false"
    center
    top="5vh"
    class="import-dialog"
  >
    <dialog-header
      slot="title"
      :title="$t('resultDialog.importResult')"
      @close="closeDialog"
    />
    <p class="sim-import-result">
      {{ $t('resultDialog.importSuccess') }}{{ successList ? successList.length : data.successedCount }}{{ $t('resultDialog.unit') }}，{{ $t('resultDialog.importFail') }}{{ failedList.length }}{{ $t('resultDialog.unit') }}
    </p>
    <ul class="all-content-info all-statistics-info">
      <li class="table-header flex-li">
        <p>
          {{ text }}
        </p>
        <p class="table-border-p-left">
          {{ $t('resultDialog.failReason') }}
        </p>
      </li>
      <div class="statistics-scroll" style="height:500px">
        <!-- <el-scrollbar style="height:100%;" wrap-class="default-scrollbar__wrap"> -->
        <li v-for="(item,index) in data.failedList" :key="index" class="flex-li content-info-li">
          <p>
            {{ item[keys] }}
          </p>
          <p class="table-border-p-left">
            {{ item.message }}
          </p>
        </li>
        <!-- </el-scrollbar> -->
      </div>
    </ul>
    <!-- <span v-show="isShow" slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel" type="primary" @click="handleCancel">{{ $t('public.cancel') }}</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
// import { exportCheckCar } from '@/api/baseData/carManage'
export default {
  name: 'ResultDialog',
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    text: {
      type: String,
      default: ''
    },
    keys: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: vm.$t('resultDialog.noFailReason')
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // isShow: true
    }
  },
  computed: {
    failedList() {
      return this.data.failedList
    },
    successList() {
      return this.data.successList
    }
  },
  watch: {},
  methods: {
    // 关闭dialog
    closeDialog() {
      this.$emit('close')
      this.$emit('update:visibles', false)
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    },
    // 导出
    handleExport() {
      if (this.data.failedList.length === 0) {
        this.$message.warning({
          message: this.message,
          duration: 2 * 1000
        })
        return false
      }
      const postData = this.data.failedList
      // exportCheckCar(postData)
      this.$emit('export-fail', postData)
    }
  }
}
</script>

<style lang="scss" scoped>
$border_color: #ebeef5;
p {
  margin: 0;
}
.sim-import-result {
  padding-bottom: 10px;
  font-weight: bold;
  font-size: 12px;
}
.all-content-info {
  padding: 0;
  margin: 0;
  .flex-li {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    p {
      flex: 1;
      text-align-last: center;
    }
    .table-border-p-left {
      border-left: 1px solid $border_color
    }
  }
  .statistics-scroll {
    overflow: auto;
    max-height: 300px;
  }
  .content-info-li {
    font-size: 13px;
    color: #999;
    border-bottom: 1px solid $border_color;
    border-left: 1px solid $border_color;
    border-right: 1px solid $border_color;
    p {
      padding: 10px 25px;
    }
  }
  .table-header {
    background-clip: content-box;
    font-size: 12px;
    border: 1px solid $border_color;
    p {
      padding: 10px 0;
    }
  }
}
.import-dialog .el-dialog, .import-dialog .el-dialog__body{
  background: #fff!important;
}
</style>
